<template>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="title"
      width="900px"
      append-to-body
      class="draw-record-dialog"
    >
      <table-tem
        v-loading="loading"
        ref="hisTable"
        :config="tableConfig"
        @changePage="changePage"
        @changePages="changePages"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
</template>

<script>
import tableTem from "@/components/tableTem/index.vue";

export default {
  props: {
    title: {
      type: String,
      default: '抽签记录'
    },
    djlcId: {
      type: String,
      default: '',
    },
    kbxm: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    tableTem,
  },

  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableConfig: {
        head: [
          {
            type: "index",
            title: "序号",
            align: "center",
            width: '100px'
          },
          {
            key: "extractTime",
            title: "抽取时间",
            align: "center",
          },
          {
            key: "extractResult",
            title: "抽取结果",
            align: "center",
          },
          {
            key: "extractUser",
            title: "抽取人",
            align: "center",
          },
        ],
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        border: true,
      },
    }
  },

  methods: {
    show() {
      this.clear();
      this.getData();
      this.dialogVisible = true;
    },

    clear() {
      this.tableConfig.data = [];
      this.tableConfig.currentPage = 1;
      this.tableConfig.pageSize = 10;
      this.tableConfig.total = 0;
    },

    async getData() {
      this.loading = true;
      const param = {
        lcId: this.djlcId,
        kbxmId: this.kbxm.id,
        page: this.tableConfig.currentPage,
        pageSize: this.tableConfig.pageSize
      };
      const res = await this.$api.listExtractRecord(param);
      this.loading = false;
      if (res.data.success) {
        this.tableConfig.data = res.data.data.data;
        this.tableConfig.total = res.data.data.total;
      } else {
        this.$message({ type: "error", message: res.data.message });
      }
    },

    changePage(e) {
      this.tableConfig.currentPage = e;
      this.getData();
    },

    changePages(e) {
      this.tableConfig.currentPage = 1;
      this.tableConfig.pageSize = e;
      this.getData();
    },
  }
}
</script>

<style lang="less" scoped>
.draw-record-dialog ::v-deep .el-dialog__body {
  padding: 20px 20px 10px;
}
.draw-record-dialog ::v-deep .pageTemp {
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
</style>